export enum WeightUnitEnum {
    KG = 'KG',
    LB = 'LB'
}
